_collow.components.ProfilePictureForm = class ProfilePictureForm extends _collow.components.Base {
  root;
  elements;
  params;
  profilePicture;

  constructor (root, elements, params) {
    super();
    this.root = root;
    this.elements = elements;
    this.params = params;

    this._assignEventListeners();
  }

  _assignEventListeners () {
    this.elements.fileinput.addEventListener('change', this._handleFileInputChange.bind(this));
  }

  _handleFileInputChange (event) {
    const file = event.target.files[0];
    const reader = new FileReader();
    const filesize = Math.ceil(file.size / 1000000);

    this.elements.uploadbutton.classList.add('is-loading');

    if (filesize > 3) {
      event.target.value = '';
      this.elements.uploadbutton.classList.remove('is-loading');
      return _collow.Notify.error(this.params.messages.profilePictureSizeError);
    }

    reader.onload = (event) => {
      this.uploadProfilePicture(file)
        .then((res) => {
          this._updateLocalStorage(res);
          _collow.instances.ProfilePicture.forEach(instance => instance.updateImagePreview(res.file_url));
          _collow.Notify.success(this.params.messages.profilePictureSuccess);
        })
        .catch(err => {
          console.error(err);
          _collow.Notify.error(this.params.messages.profilePictureError);
        })
        .finally(() => {
          this.elements.uploadbutton.classList.remove('is-loading');
          event.target.value = '';
        });
    };

    reader.readAsDataURL(file);
  }

  async uploadProfilePicture (file) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('picture', file);
  
      fetching(
        this.params.api + '/user/profile_picture',
        "PUT",
        formData,
        {
          headers: {
            'Content-Type': undefined
          },
        }
      )
      .then(res => {
        return resolve(res.profile_picture)
      })
      .catch(err => reject(err));
    })
  }

  _updateLocalStorage (profile_picture) {
    const progressJson = window.localStorage.getProgressJson();
    progressJson.profile_picture = profile_picture;
    window.localStorage.setItem('progressJson', JSON.stringify(progressJson));
  }
}
